//This is the main function of a Chart.

/**
 * @param {Object} container - DOM element in which the chart will be rendered
 * @param {(Object | Array)} data - Data for the chart
 * @returns {Object} Main chart object
 */
import anychart from "anychart"
import { get } from "jquery";
import dayjs from "dayjs";

import '../../../translations/anychart/sv-se.js';
import { isoFormat, formatDateFullTime, formatDateTime, formatDate, formatTime, formatDateTimeISO } from "../../../utils/dateTimeUtils";      
//const localexx = require('anychart/dist/locales/sv-se.js');
//anychart.format.locales["sv-se"];


const language = localStorage.getItem('language') || 'en'
let activeNowMarkerIntervalId = null;

console.log("anychartGantt language:", language);

export const gantChart = (container, data, onClickHandler, colors, startDate, endDate, companyKey, ganttDarkMode, company, featureFlags, handleUpdateData, timeSpan, handleOpenNewPO, pEdit, pCheckboxClick, pMarkedForUpdate, pRowUndoClick, pZoomLevel, pSetZoomLevel, pDefaultOee, pBlockValue, pRowSaveClick) => {  //redrawChart
    var fromDate = new Date(startDate);
    var toDate = new Date(endDate);

   //const isoFormat = "YYYY-MM-DDTHH:mm:ss";
    //const isoFormatSmallTime = "YYYY-MM-DD HH:mm";

    //console.log("anychartGantt: " + fromDate + " toDate: " + toDate);
    //console.log("anychartGantt Data:", data);

    function capitalize(str) {
        return str[0].toUpperCase() + str.slice(1);
    }

    function getDayInterval() {

        let start = fromDate;
        let end = toDate;
        if (start === undefined || start === null || end === undefined || end === null) {
            return 1; // Default to 1 day if no start or end date is provided
        }
        // get number of days between start and end date
        const startDate = new Date(start);
        const endDate = new Date(end);

        const timeDiff = endDate.getTime() - startDate.getTime();
        const dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24)); // Convert milliseconds to days

        //return dayDiff > 0 ? dayDiff : 1; // Ensure at least 1 day interval

        let interval = 1; // Default to 1 day interval

        //alert("getDayInterval: " + dayDiff);


        if (dayDiff < 8) {
            interval = 1; // Return 1 day interval if less than 7 days
        }
        else if (dayDiff < 31) {
            interval = 3; // Return 3 days interval if less than 30 days
        }
        else {
            interval = 7; // Return 7 days interval if less than 90 days
        }

        return interval;
    }

    function getHourAndMinutesFromMinutes(totalMinutes) {
        if (isNaN(totalMinutes) || totalMinutes === null || totalMinutes === undefined || totalMinutes <= 0) {
            return { hours: "-", minutes: "-" };
        }
        const hours = (Math.floor(totalMinutes / 60)).toFixed(0);
        const minutes = (totalMinutes % 60).toFixed(0);
        return { hours, minutes };
    }

    function getHourInterval() {

        let start = fromDate;
        let end = toDate;

        if (start === undefined || start === null || end === undefined || end === null) {
            return 1; // Default to 1 hour if no start or end date is provided
        }
        // get number of hours between start and end date
        const startDate = new Date(start);
        const endDate = new Date(end);
        const timeDiff = endDate.getTime() - startDate.getTime();
        const hourDiff = Math.ceil(timeDiff / (1000 * 3600)); // Convert milliseconds to hours
        const dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24)); // Convert milliseconds to days

        let interval = 1; // Default to 1 day interval

        //alert("getHourInterval: " + hourDiff + " dayDiff: " + dayDiff);

        if (dayDiff < 8) {
            interval = 4; // Return 1 hour interval if less than 7 days
        } else if (dayDiff < 31) {
            interval = 12; // Return 24 hours interval if more than 7 days
        } else {
            interval = 24; // Return 24 hours interval if more than 30 days
        }

        return interval;
    }

    function isActivePO(pPO, pActivePO) {
        if (pPO !== undefined && pPO !== null && pActivePO !== undefined && pActivePO !== null) {
            if (pPO.toString() === pActivePO.toString()) {
                return true; // This is the active production order
            }
        }
        return false;
    }

    function getErpStatusSymbol(pErpStatus) {
        // Pyramid status
        // 0 – Prognos
        // 1 – Registrerad
        // 2 – Reserverad
        // 3 – Uttag gjorda
        // 4 – Återrapporterad
        // 7 – Vilande
        // 9 – Avslutad

        //▶ ► ✔ ⏸ ↓ ▼

        let ongoing = "";
        switch (pErpStatus) {
            case "1":
                ongoing = ""; // No symbol for registered
                break;
            case "2":
                ongoing = ""; // No symbol for reserved
                break;
            case "4":
                ongoing = "▼ ";
                break;
            case "7":
                ongoing = "⏸ ";
                break;
            case "9":
                ongoing = "✔ ";
                break;
            case null:
                ongoing = "New";
                break;
            default:
                ongoing = ""; //pErpStatus + ":";
                break;
        }
        return ongoing;


    }

    function getBlockInfo(pStart, pEnd, ongoing, pStarted, pPO, pActivePO, pType, pErpStatus, pEditing, pRowType, pColor) {

        let result = { color: color, reasonText: "" }

        if (pEditing === true) {
            result.color = "#213046ff" // "#4b6b9bff"
            result.reasonText = "update is pending";
            return result;
        }

        if (pRowType === 2) {
            result.color = pColor // "#4b6b9bff"
            result.reasonText = "Blockers";
            return result;
        }

        let active = isActivePO(pPO, pActivePO);

        let start = new Date(pStart);
        let end = new Date(pEnd);

        // const colorCurrentOk = "#92d125"; // Default color for past ok
        // const colorCurrentLate = "#db4f4a"; // Default color for past late
        // const colorUpcoming = "#aaaaaa"; // Default color for upcoming
        // const colorPastOk = "#7C9C45"; // Default color for past ok
        // const colorRunningOK = "#92d125"; // Default color for past ok
        // const colorPastLate = "#db4f4a"; // Default color for past late
        // const colorLate = "#db4f4a"; // Default color for past late
        // const colorRunningLate = "#fc3b35aa"; // Default color for past late

        const colorCurrentOk = "#aaaaaa"; // Default color for past ok
        const colorCurrentLate = "#db4f4a"; // Default color for past late
        const colorUpcoming = "#86a8e2ff"; // Default color for upcoming
        const colorPastOk = "#aaaaaa"; // Default color for past ok
        const colorRunning = "#799c4a" //"#92d125"; // Default color for past ok
        const colorPastLate = "#db4f4a"; // Default color for past late
        const colorLate = "#db4f4a"; // Default color for past late
        const colorRunningLate = "#aaaaaa"; // Default color for past late

        var color = "#00ffffaa"   // Default color for unknown state

        // if (pPO !== undefined && pPO !== null && pActivePO !== undefined && pActivePO !== null) {
        //     if (pPO.toString() === pActivePO.toString() && pType === "main") {
        //         if (end < Date.now()) {
        //             return { color: colorRunningLate, reasonText: "PO is running but is late" };
        //         }
        //     }
        // }

        // if (pProjectedEndTime !== undefined && pProjectedEndTime !== null && (new Date(pProjectedEndTime) > new Date(pEnd))) {
        //     return "#db4f4a"; // Projected end time is later than actual end time
        // }

        if (active) {

            result.color = colorRunning; // Current late
            result.reasonText = "PO is running";


            // if (start < Date.now() && end > Date.now()) {
            //     result.color = colorCurrentOk; // Current ok
            //     result.reasonText = "PO is running OK";
            // }
            // else if (start < Date.now() && end < Date.now()) {
            //     result.color = colorRunningLate; // Current late
            //     result.reasonText = "PO is running late";
            // }
            // else if (start > Date.now() && end > Date.now()) {
            //     result.color = colorCurrentOk; // Current late
            //     result.reasonText = "PO is running before planned startdate";
            // }
        } else {

            if (start > Date.now()) {
                result.color = colorUpcoming; // Upcoming
                result.reasonText = "PO is not started and planned for later";
            }
            else if (start < Date.now() && end > Date.now()) {
                result.color = colorCurrentLate; // Past ok
                result.reasonText = "PO is not running but planned for now";
            }
            else if (start < Date.now() && end < Date.now() && pStarted === 0) {
                result.color = colorLate;
                result.reasonText = "PO is not running and never started";
            }
            else if (start < Date.now() && end < Date.now() && pStarted !== 0) {
                result.color = colorPastOk; // Past ok
                result.reasonText = "PO is not running and was started - OK?";
            }
            else {
                result.color = "#ff00ff"; // Past late
                result.reasonText = "PO status is not possible to determine 1";
            }

            // else if (end < Date.now()) {
            //     color = colorPastOk; // Past ok
            // }
            // else if (end > Date.now()) {
            //     color = colorRunningOK; // Past late
            // }
        }

        if (color === undefined || color === null || color === "") {
            result.color = "#ffffff"; // Default color for unknown state
            result.reasonText = "PO status is not possible to determine 2";
        }

        if (pType === "prog") {
            //result.color = "#92d125aa";
            result.color = "#ffffff33";
            return result;
        }
        if (pType === "calc") {
            //result.color = "#92d125aa";
            result.color = "#770000ff";
            return result;
        }

        if (pType === "replanned") {
            result.color = "#4b6b9bff";
            return result;
        }

        return result;
    }


    // Extra height on rows if few machines
    let count = 0;
    data.forEach(element => {
        if (element.children) {
            count += element.children.length;
        }
    });
    //##### set row height if les than 10 rows, hight
    if (count <= 100) {
        data.forEach(element => {
            element.rowHeight = 30;
            element.children.forEach(element => {
                element.rowHeight = 40;
            })
        });
    }

    //function to remove anychart credits
    function removeElementsByClass() {
        const elements = document.getElementsByClassName("anychart-credits");
        while (elements.length > 0) {
            elements[0].parentNode.removeChild(elements[0]);
        }

    };

    function isGrouping(item) {
        if (item.get('statusColor') === undefined) {
            return true;
        }
        return false;
    }

    // function getAvalability(item) {
    //     var avail = item.get('avail24h')
    //     var oeePercentBad = item.get('oeePercentBad');
    //     var oeePercentWarning = item.get('oeePercentWarning');
    //     var availabilityPercentWarning = item.get('availabilityPercentWarning');
    //     var availabilityPercentBad = item.get('availabilityPercentBad');
    //     var companyOeePercentBad = company.oeePercentBad;
    //     var companyOeePercentWarning = company.oeePercentWarning;
    //     var companyAvailabilityPercentWarning = company.availabilityPercentWarning;
    //     var companyAvailabilityPercentBad = company.availabilityPercentBad;

    //     var percentBad = 65;
    //     var percentWarning = 78;

    //     if (availabilityPercentBad && availabilityPercentBad !== null) {
    //         percentBad = availabilityPercentBad;
    //     }
    //     else if (companyAvailabilityPercentBad && companyAvailabilityPercentBad !== null) {
    //         percentBad = companyAvailabilityPercentBad;
    //     }
    //     else if (oeePercentBad && oeePercentBad !== null) {
    //         percentBad = oeePercentBad;
    //     }
    //     else if (companyOeePercentBad && companyOeePercentBad !== null) {
    //         percentBad = companyOeePercentBad;
    //     }

    //     if (availabilityPercentWarning && availabilityPercentWarning !== null) {
    //         percentWarning = availabilityPercentWarning;
    //     }
    //     else if (companyAvailabilityPercentWarning && companyAvailabilityPercentWarning !== null) {
    //         percentWarning = companyAvailabilityPercentWarning;
    //     }
    //     else if (oeePercentWarning && oeePercentWarning !== null) {
    //         percentWarning = oeePercentWarning;
    //     }
    //     else if (companyOeePercentWarning !== null) {
    //         percentWarning = companyOeePercentWarning;
    //     }

    //     var availColor = "";
    //     if (avail < percentBad) {
    //         availColor = "#af3f3b";
    //     }
    //     else if (avail > percentBad && avail < percentWarning) {
    //         availColor = "#ffc107";
    //     }
    //     else if (avail >= percentWarning) {
    //         availColor = "#26b334";
    //     } else {
    //         availColor = "#ff00ff";
    //     }



    //     return `<div style="width:40px"><font size='1' color=${availColor}>(${avail}%)</font></div>`
    // }

    function getStatusIcon(item) {
        var status = item.item.la?.machineStatus; //.get('statusColor')
        var statusColor = "";
        if (status === "Running") {
            statusColor = "#26b334";
        }
        if (status === "Offline") {
            statusColor = "orange";
        }
        if (status === "Stopped") {
            statusColor = "#af3f3b";
        }
        return `<div><i class='fas fa-square' style='color: ${statusColor}'></i></div>`

    }

    // function getMaintenance24h(item) {
    //     const isMaintainanceEnabled = featureFlags.some(f => f.name === "ShowMaintenanceInGantt" && f.isEnabled === true);
    //     if (!isMaintainanceEnabled) {
    //         return "";
    //     }

    //     var maint24 = item.get('haveMaint24h');
    //     if (maint24 === 1) {
    //         return "<div><i class='fas fa-wrench' style='color: orange'></i></div>";
    //     }
    //     else {
    //         return "";
    //     }
    // }


    function getPriority(item) {

        let icon = item.item.la?.machinePriorityIcon?.toString();
        switch (icon) {
            case "LooksOne":
                return "<img src='../../../assets/1.png' height='15px'/>";
            case "LooksTwo":
                return "<img src='../../../assets/2.png' height='15px'/>";
            case "Looks3":
                return "<img src='../../../assets/3.png' height='15px'/>";
            case "Looks4":
                return "<img src='../../../assets/4.png' height='15px'/>";
            case "Looks5":
                return "<img src='../../../assets/5.png' height='15px'/>";
            case "Looks6":
                return "<img src='../../../assets/6.png' height='15px'/>";
            case "Looks7":
                return "<img src='../../../assets/7.png' height='15px'/>";
            case "Looks8":
                return "<img src='../../../assets/8.png' height='15px'/>";
            case "Looks9":
                return "<img src='../../../assets/9.png' height='15px'/>";
            case "LooksFive":
                return "<img src='../../../assets/5.png' height='15px'/>";
            case "LooksSix":
                return "<img src='../../../assets/6.png' height='15px'/>";
            case "LooksSeven":
                return "<img src='../../../assets/7.png' height='15px'/>";
            case "LooksEight":
                return "<img src='../../../assets/8.png' height='15px'/>";
            case "LooksNine":
                return "<img src='../../../assets/9.png' height='15px'/>";
            case "ArrowUpward":
                return "<img src='../../../assets/up.png' height='15px'/>";
            case "ArrowDownward":
                return "<img src='../../../assets/down.png' height='15px'/>";
            case "ArrowForward":
                return "<img src='../../../assets/right.png' height='15px'/>";
            default:
                return "";
        }
    }

    function formatDateAndTime(date) {
        return formatDateTime(language, date);
    }

    function labelTextSettingsOverrider(label, item) {
        if (isGrouping(item)) {
            return;
        }

        label.useHtml(true);
        let machineColor = "#cccccc";
        if (ganttDarkMode === "false") {
            machineColor = "#333333";
        }

        let formatString = `<div class="gantt-header-container">${getStatusIcon(item)} <div style="min-width:35px"><a href='/machines/{%id}' style='color: ${machineColor}'>{%name}</a></div> ${getPriority(item)}...</div><div>+</div>`;

        label.format(formatString);
    }


    function calculateRemaingTime(maxClosedDate) {
        let timeRemaining = (new Date(maxClosedDate) - Date.now()) / 1000;
        // Convert seconds to hours, minutes, and seconds
        const hours = Math.floor(timeRemaining / 3600);
        const minutes = Math.floor((timeRemaining % 3600) / 60);
        const seconds = Math.floor(timeRemaining % 60);

        return `${hours} h ${minutes} m ${seconds} s`;
    }

    // locales
    //console.log("anychartGantt setting locale for language:", language);
    if (language === "sv") {
        anychart.format.inputLocale('sv-se');
        anychart.format.outputLocale('sv-se');
        anychart.format.inputDateTimeFormat('yyyy-MM-dd\'T\'HH:mm:ss');
    } else {
        anychart.format.inputLocale('en-us');
        anychart.format.outputLocale('en-us');
        anychart.format.inputDateTimeFormat('yyyy-MM-dd\'T\'HH:mm:ss');
    }

    var treeData = anychart.data.tree(data, "as-tree");
    var chart = anychart.ganttResource();
    //var chart = anychart.ganttProject();
    chart.data(treeData);
    chart.container("container");


    chart.edit(pEdit === "true");


    // Get current period, used to determine which period to update
    let currentPeriod = null;
    chart.listen("rowMouseOver", function (e) {
        if (e.elementType === "periods") {
            currentPeriod = e.period.id;
        }
    });

    // listen to the treeItemUpdate event. Use currentPeriod to determine which period to update
    treeData.listen("treeItemUpdate", function (e) {
        let periods = e.item.get("periods");


        let currentDataPeriod = periods.find(p => p.id === currentPeriod);
        if (isNaN(currentDataPeriod.end.toString())) {
            //console.log("Invalid date detected, not updating PO");
            return; //invalid date
        }

        //console.log("treeItemUpdate", e.item.get("name"), currentPeriod, periods);
        //console.log("treeItemUpdate data", e.item, currentPeriod, periods);

        //alert("move!");

        handleUpdateData(currentPeriod, periods);
    });

    /* listen to the treeItemMove event
    and update the chart title */
    //#####
    // treeData.listen("treeItemMove", function (e) {
    //     //console.log("treeItemMove", e.item.la);
    //     //alert("treeItemMove", e.item.get("name"));
    // });

    // set start splitter position settings
    chart.splitterPosition(200);
    chart.background("#434957");


    // configure baselines
    // let baselines = chart.getTimeline().baselines();
    // baselines.normal().fill("#dd2c00 0.3");
    // baselines.normal().stroke(null);
    // baselines.selected().fill("#ef6c00 0.3");
    // baselines.selected().stroke(null);
    // baselines.above(true);

    // get chart data grid link to set column settings
    var dataGrid = chart.dataGrid();


    if (ganttDarkMode === "true") {
        dataGrid.rowEvenFill("#434957 0.9");
        dataGrid.rowFill("#434957 0.9");
        dataGrid.headerFill("#434957 0.9")
        dataGrid.rowHoverFill("#101624 1");
        dataGrid.rowSelectedFill("#999999 0.3");
    } else {
        dataGrid.rowFill("#ffffff 1");
        dataGrid.rowEvenFill("#ffffff 1");
        dataGrid.headerFill("#ffffff 1")
        dataGrid.rowHoverFill("#e9e9e9 0.8");
        dataGrid.rowSelectedFill("#999999 0.3");
    }
    dataGrid.columnStroke("2 #101624");
    dataGrid.columnStroke("1 #101624");
    dataGrid.columnStroke("0 #101624");
    dataGrid.rowStroke("#101624");



    // hide first column
    dataGrid.column(0).enabled(false);

    // get chart timeline
    var timeLine = chart.getTimeline();

    var elements = timeLine.elements();


    // configure duration thumbs. For grabbing and streching elements
    // elements.edit().thumbs().size(7);
    // elements.edit().thumbs().stroke("#ffffff", 1);
    // elements.edit().thumbs().fill("#aaaaaa");
    elements.edit().thumbs().enabled(false);

    // configure connector thumbs
    elements.edit().connectorThumbs().enabled(false);
    //elements.edit().connectorThumbs().size(0);



    // set base fill
    timeLine.elements().fill(function () {
        // get status from data item
        //var status = this.period.status;
        // set fill color by status
        var statusColor = "#00ffffaa"; // Default color for unknown state
        if (this.period.type === "calendar") {
            statusColor = this.period?.color;
        } else {
            statusColor = getBlockInfo(this.period.plannedOrReplannedStartTime, this.period.plannedOrReplannedEndTime, this.period.ongoing, this.period.reportedQty, this.period.productionOrderId, this.period.activePO, this.period.type, this.period.erpStatus, this.period.editing, this.period.rowType, this.period.blockerColor)?.color;
        }

        // create fill object
        var fill = {
            // if this element has children, then add opacity to it
            opacity: this.item.numChildren() ? 1 : 0.7
        };
        fill.color = statusColor;
        return fill;
    });

    timeLine.columnStroke(null);


    if (ganttDarkMode === "true") {
        timeLine.rowHoverFill("#101624 1");
        timeLine.rowFill("#434957 0.9");
        timeLine.rowEvenFill("#434957 0.9");
        timeLine.rowSelectedFill("#999999 0.3");
    } else {
        timeLine.rowHoverFill("#e9e9e9 0.8");
        timeLine.rowEvenFill("ffffff 1");
        timeLine.rowFill("#ffffff 1");
        timeLine.rowSelectedFill("#ffd54f 0.3");
    }
    timeLine.rowStroke("#101624 0.8");

    // set base stroke
    //timeLine.elements().stroke('none');
    //timeLine.elements().stroke('#ffffff 0.8');


    // set base fill
    timeLine.elements().stroke(function () {

        if (isActivePO(this.period?.productionOrderId || "", this.period?.activePO)) {
            return "#ffffff 0.8";
        } else {
            return "#000000";
        }

    });





    var header = chart.getTimeline().header();
    if (ganttDarkMode === "true") {
        header.fill("#434957");
        header.fontColor("#ffffff");
    } else {
        header.fill("#ffffff");
        header.fontColor("#434957");
    }
    header.stroke("#101624 0.8");

    // set first column settings
    var firstColumn = dataGrid.column(1);
    firstColumn.labels().hAlign('left');
    firstColumn

        .title('')
        .width(200)

        .labelsOverrider(labelTextSettingsOverrider)
        .labels()
        .format(function () {
            return this.name;
        });


    // set first column settings

    chart.getTimeline().scale().zoomLevels([
        [
            // { unit: "hour", count: 12 },
            // { unit: "day", count: 5 }
            // { unit: "hour", count: getHourInterval() },
            // { unit: "day", count: getDayInterval() },
            { unit: "hour", count: 1 },
            { unit: "day", count: 1 },
            { unit: "week", count: 1 },
            { unit: "month", count: 1 }
        ]
    ]);
    // set container id for the chart
    //chart.container(container);
    //var header = chart.getTimeline().header();
    if (language === "sv") {
        header.level(0).format(function () {
            return anychart.format.dateTime(this.tickValue, "H");
        });

        header.level(1).format(function () {
            var date = new Date(this.tickValue);
            var day = date.getDay(); // 0 = Sunday, 6 = Saturday

            return anychart.format.dateTime(this.tickValue, "d") + " " + anychart.format.dateTime(this.tickValue, 'E').charAt(0).toUpperCase();
        });
        // week
        header.level(2).format(function () {
            return "V." + (parseInt(anychart.format.dateTime(this.tickValue, "ww")) + 1);
        });
        // month and year level
        header.level(3).format(function () {
            return capitalize(anychart.format.dateTime(this.tickValue, "MMMM yyyy"));
        });

    }
    if (language === "en") {
        header.level(0).format("{%tickValue}{dateTimeFormat:hh a}");

        header.level(1).format(function () {
            var date = new Date(this.tickValue);
            var day = date.getDay(); // 0 = Sunday, 6 = Saturday

            return anychart.format.dateTime(this.tickValue, "d") + " " + anychart.format.dateTime(this.tickValue, 'E').charAt(0).toUpperCase();
        });
        // week
        header.level(2).format(function () {
            return "V." + (parseInt(anychart.format.dateTime(this.tickValue, "ww")) + 1);
        });
        // month and year level
        header.level(3).format(function () {
            return capitalize(anychart.format.dateTime(this.tickValue, "MMMM yyyy"));
        });
    }
    // configure tooltips of the timeline
    chart.dataGrid().tooltip(false);

    chart.getTimeline().tooltip().useHtml(true);
    if (language === "en") {
        chart.getTimeline().tooltip().format(function () {
            if (!this.period) { return "" }
            if (this.period?.type === "calendar") {
                return `<b>Calendar - Shift</b><br/> 
                ${this.period.shiftName}<br/>
                ${formatDateAndTime(this.period.start)} <br/> ${formatDateAndTime(this.period.end)}`;
            }
            return "<table>" +
                `<tr><td>PO:</td><td> ${this.period.productionOrderId}</td></tr>` +
                `<tr><td>PO status:</td><td> ${getBlockInfo(this.period.plannedOrReplannedStartTime, this.period.plannedOrReplannedEndTime, this.period.ongoing, this.period.reportedQty, this.period.productionOrderId, this.period.activePO, this.period.type, this.period.erpStatus, this.period.editing, this.period.rowType)?.reasonText}</td></tr>` +
                `<tr><td>Erp status:</td><td> ${getErpStatusSymbol(this.period.erpStatus)}</td></tr>` +
                //`<tr><td>Operation:</td><td> ${"1hc"}</td></tr>` +
                `<tr><td>Article:</td><td> ${this.period?.itemNo} - ${this.period?.itemName}</td></tr>` +
                `<tr><td>Planned Start time:</td><td> ${anychart.format.dateTime(this.period.plannedStartTime, "MM/dd/yyyy hh:mm a")}</td></tr>` +
                `<tr><td>Planned End time:</td><td> ${anychart.format.dateTime(this.period.plannedEndTime, " MM/dd/yyyy hh:mm a")}</td></tr>` +
                `<tr><td>Replanned Start time:</td><td> ${anychart.format.dateTime(this.period.replannedStartTime, "MM/dd/yyyy hh:mm a")}</td></tr>` +
                `<tr><td>Replanned End time:</td><td> ${anychart.format.dateTime(this.period.replannedEndTime, " MM/dd/yyyy hh:mm a")}</td></tr>` +
                //`<tr><td>Actual start:</td><td> ${anychart.format.dateTime(this.period.actualStartTime, "MM/dd/yyyy hh:mm a")}</td></tr>` +
                //`<tr><td>Actual end:</td><td> ${anychart.format.dateTime(this.period.actualEndTime, "MM/dd/yyyy hh:mm a")}</td></tr>` +
                // `<tr><td>Calculated start:</td><td> ${anychart.format.dateTime(this.period.calculatedStartTime, "MM/dd/yyyy hh:mm a")}</td></tr>` +
                // `<tr><td>Calculated end:</td><td> ${anychart.format.dateTime(this.period.calculatedEndTime, "MM/dd/yyyy hh:mm a")}</td></tr>` +
                // `<tr><td>Presenterad start:</td><td> ${formatDateAndTime(this.period.start)}</td></tr>` +
                // `<tr><td>Presenterad sluttid:</td><td> ${formatDateAndTime(this.period.end)}</td></tr>` +
                //`<tr><td>Planned production time:</td><td> ${this.period.plannedProductionTime} minutes</td></tr>` +
                //`<tr><td>Actual production time:</td><td> ${this.period.actualProductionTime} minutes</td></tr>` +
                `<tr><td>Ideal cycle time:</td><td> ${this.period.idealCycleTime} seconds</td></tr>` +
                //`<tr><td>Actual cycle time:</td><td> ${this.period.actualCycleTime} seconds</td></tr>` +
                `<tr><td>Planned qty:</td><td> ${this.period.plannedQty} pieces</td></tr>` +
                `<tr><td>Reported qty:</td><td> ${this.period.reportedQty} pieces</td></tr>` +
                `<tr><td>Calculated run time:</td><td> ${getHourAndMinutesFromMinutes(this.period.calculatedRunTime).hours} hours ${getHourAndMinutesFromMinutes(this.period.calculatedRunTime).minutes} minutes</td></tr>` +
                `<tr><td>Calculated time to end:</td><td> ${getHourAndMinutesFromMinutes(this.period.calculatedTimeToEnd).hours} hours ${getHourAndMinutesFromMinutes(this.period.calculatedTimeToEnd).minutes} minutes</td></tr>` +
                `<tr><td>Historic/default OEE:</td><td> ${(this.period.historicOee || pDefaultOee * 100).toFixed(2)} %</td></tr>` +
                `<tr><td>Selected OEE Value:</td><td> ${this.period.oeeValue != null ? ((this.period.oeeValue * 100).toFixed(2) + " %") : ""}</td></tr>` +
                `<tr><td>Tool:</td><td> ${this.period.tool}</td></tr>` +

                "</table>";
        });
    }
    if (language === "sv") {
        chart.getTimeline().tooltip().format(function () {
            if (!this.period) { return "" }

            if (this.period?.type === "calendar") {
                return `<b>Kalender - Skift</b><br/> 
                ${this.period.shiftName}<br/>
                ${formatDateAndTime(this.period.start)} <br/> ${formatDateAndTime(this.period.end)}`;
            }
            return "<table>" +
                `<tr><td>Produktionsorder:</td><td> ${this.period.productionOrderId}<br>` +
                `<tr><td>PO status:</td><td> ${getBlockInfo(this.period.plannedOrReplannedStartTime, this.period.plannedOrReplannedEndTime, this.period.ongoing, this.period.reportedQty, this.period.productionOrderId, this.period.activePO, this.period.type, this.period.erpStatus, this.period.editing, this.period.rowType)?.reasonText}</td></tr>` +
                `<tr><td>Erp status:</td><td> ${getErpStatusSymbol(this.period.erpStatus)}</td></tr>` +
                //`<tr><td>Operation:</td><td> ${"1hc"}<br> ` +
                `<tr><td>Article:</td><td> ${this.period.itemNo} - ${this.period.itemName}</td></tr>` +
                `<tr><td>Planerad Starttid:</td><td> ${formatDateAndTime(this.period.plannedStartTime)}</td></tr> ` +
                `<tr><td>Planerad Sluttid:</td><td> ${formatDateAndTime(this.period.plannedEndTime)}</td></tr>` +
                `<tr><td>Omplanerad Starttid:</td><td> ${formatDateAndTime(this.period.replannedStartTime)}</td></tr> ` +
                `<tr><td>Omplanerad Sluttid:</td><td> ${formatDateAndTime(this.period.replannedEndTime)}</td></tr>` +
                //`<tr><td>Faktisk starttid:</td><td> ${formatDateAndTime(this.period.actualStartTime)}</td></tr>` +
                //`<tr><td>Faktisk sluttid:</td><td> ${formatDateAndTime(this.period.actualEndTime)}</td></tr>` +
                // `<tr><td>Beräknad start:</td><td> ${formatDateAndTime(this.period.calculatedStartTime)}</td></tr>` +
                // `<tr><td>Beräknad sluttid:</td><td> ${formatDateAndTime(this.period.calculatedEndTime)}</td></tr>` +
                // `<tr><td>Presenterad start:</td><td> ${formatDateAndTime(this.period.start)}</td></tr>` +
                // `<tr><td>Presenterad sluttid:</td><td> ${formatDateAndTime(this.period.end)}</td></tr>` +
                //`<tr><td>Planerad produktionstid:</td><td> ${this.period.plannedProductionTime} min</td></tr>` +
                //`<tr><td>Faktisk produktionstid:</td><td> ${this.period.actualProductionTime} min</td></tr>` +
                `<tr><td>Ideal cykeltid:</td><td> ${this.period.idealCycleTime} s</td></tr>` +
                //`<tr><td>Faktisk cykeltid:</td><td> ${this.period.actualCycleTime} s</td></tr>` +
                `<tr><td>Planerad kvantitet:</td><td> ${this.period.plannedQty} st</td></tr>` +
                `<tr><td>Rapporterad kvantitet:</td><td> ${this.period.reportedQty} st</td></tr>` +
                `<tr><td>Calculated run time:</td><td> ${getHourAndMinutesFromMinutes(this.period.calculatedRunTime).hours} hours ${getHourAndMinutesFromMinutes(this.period.calculatedRunTime).minutes} minutes</td></tr>` +
                `<tr><td>Calculated time to end:</td><td> ${getHourAndMinutesFromMinutes(this.period.calculatedTimeToEnd).hours} hours ${getHourAndMinutesFromMinutes(this.period.calculatedTimeToEnd).minutes} minutes</td></tr>` +
                `<tr><td>Historic/default OEE:</td><td> ${(this.period.historicOee || pDefaultOee * 100).toFixed(2)} %</td></tr>` +
                `<tr><td>Selected OEE Value:</td><td> ${this.period.oeeValue != null ? ((this.period.oeeValue * 100).toFixed(2) + " %") : ""}</td></tr>` +
                `<tr><td>Tool:</td><td> ${this.period.tool}</td></tr>` +
                "</table>"

        });
    }


    //Show if there are any comments
    var tl = chart.getTimeline();
    // ####
    // tl.elements()
    //     .labels()
    //     .enabled(true)
    //     .fontColor('#fff')
    //     .format(function () {
    //         var comment = this.period.comment;
    //         var label = this.label;
    //         if (comment != null) {
    //             if (comment.length > 1) {
    //                 comment = '*';
    //             } else {
    //                 comment = '';
    //             }
    //         } else {
    //             comment = '';
    //         }
    //         return comment;

    //     })
    //     .textShadow({
    //         color: '#333333',
    //         offsetX: '1px',
    //         offsetY: '1px',
    //         blurRadius: '1px'
    //     });

    tl.elements()
        .labels()
        .enabled(true)
        .fontColor('#fff')
        .format(function () {

            var po = "";
            switch (pBlockValue) {
                case "PO":
                    po = this.period.productionOrderId;
                    break;
                case "Tool":
                    po = this.period.tool;
                    break;
                case "Item":
                    po = this.period.itemNo;
                    break;
                default:
                    po = this.period.productionOrderId
                    break;
            }

            if (this.period.rowType === "" || this.period.rowType === null || this.period.rowType === undefined) {
                po = this.period.productionOrderId;
            };

            // if(this.period.rowType === "blocker") {
            //     po = this.period.blockerDescription || "Blocker";
            // }


            if (this.period.productionOrderId.toString().startsWith("x_")) {
                po = "NEW";
            }
            if (this.period.blockerDescription && this.period.blockerDescription.length > 0) {
                po = this.period.blockerDescription;
            }



            //var po = this.period.blockerDescription ?? this.period.productionOrderId.toString().startsWith("x_") ? "NEW" : this.period.productionOrderId;
            var ongoing = "";
            if (this.period.type === "prog" || this.period.type === "calc") {
                return "";
            }
            // Symbol for ongoing or status
            if (isActivePO(this.period.productionOrderId, this.period.activePO)) {
                //ongoing = String.fromCodePoint(9733);
                //ongoing = String.fromCodePoint(10148) + " ";
                ongoing = String.fromCodePoint(9654) + " ";  //play
                //ongoing = "▶ ";
                //ongoing = "► ";
                //ongoing = "✔ ";
                //ongoing = "⏸ ";
                //ongoing = "↓ ";
                //ongoing = "▼ ";

                //ongoing = String.fromCodePoint(128512) + " ";
            } else {

                ongoing = getErpStatusSymbol(this.period.erpStatus);
                //no symbol if new
                if (po === "NEW") {
                    ongoing = "";
                }

                // Pyramid status
                // 0 – Prognos
                // 1 – Registrerad
                // 2 – Reserverad
                // 3 – Uttag gjorda
                // 4 – Återrapporterad
                // 7 – Vilande
                // 9 – Avslutad
            }

            // var label = this.label;
            // if (comment != null) {
            //     if (comment.length > 1) {
            //         comment = '*';
            //     } else {
            //         comment = '';
            //     }
            // } else {
            //     comment = '';
            // }

            //removed operation as it is missing now
            //return po ? 'PO:' + po + ' OP:1' : '';
            return po ? ongoing + '' + po : '';

        })
        .textShadow({
            color: '#333333',
            offsetX: '1px',
            offsetY: '1px',
            blurRadius: '1px'
        });


    // Get current date/time
    var now = new Date();


    //#####

    timeLine.scale().minimum(Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate() - 1, (fromDate.getHours()), fromDate.getMinutes(), fromDate.getSeconds()));
    timeLine.scale().maximum(Date.UTC(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), (toDate.getHours() + 1), toDate.getMinutes(), toDate.getSeconds()));



    //console.log("date", formatDateAndTime(new Date(timeLine.scale().minimum())), formatDateAndTime(new Date(timeLine.scale().maximum())));

    //const now = new Date();
    //let tempStart = new Date(now.getTime() + (25 * 60 * 60 * 1000)).toISOString().replace("T", " ").replace("Z", "");

    //timeLine.scale().minimum(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), (fromDate.getHours()), fromDate.getMinutes(), fromDate.getSeconds());
    //timeLine.scale().maximum(new Date(now.getTime() + (25 * 60 * 60 * 1000) ));

    // chart.listen("rowClick", function (e) {
    //     if (e.elementType === "periods") {
    //         //codeStopModal(e.period.id,  parseInt(e.item.get("id")));
    //         console.log("rowClick", e.period.id);

    //     }
    //     e.preventDefault();
    // });

    //chart.listen("rowDblClick", function (e) {
    // chart.listen("rowClick", function (e) {

    //     if (e.elementType === "periods") {
    //         //codeStopModal(e.period.id,  parseInt(e.item.get("id")));
    //         //console.log("rowClick", e.period.id, e.period);
    //         onClickHandler(e.period)
    //         //var itemName = e.item.get("name");
    //     }
    // });






    // timeline.listen("pointClick", function (e) {

    //     console.log ("pointClick event:", e);

    //     const scale = timeLine.scale();
    //     // 1) Period/task times (from data item)
    //     const item = e.item;
    //     // Prefer actualStart/actualEnd if you use progress/baselines; else fall back to start/end
    //     const start = item.get("actualStart") || item.get("start");
    //     const end = item.get("actualEnd") || item.get("end");

    //     console.log("Period start:", new Date(start));
    //     console.log("Period end  :", new Date(end));

    //     // 2) Mouse date at the click position (convert pixel -> time)
    //     // Get timeline pixel bounds relative to the page
    //     const tlBounds = timeline.container().getBounds(); // page-space bounds
    //     const xPix = e.clientX - tlBounds.left;            // x inside the timeline panel

    //     // Convert pixel to ratio [0..1] across the timeline panel
    //     const ratio = xPix / tlBounds.width;

    //     // Inverse map ratio -> timestamp using the timeline scale
    //     const clickedDate = new Date(scale.inverseTransform(ratio));

    //     console.log("Date under cursor:", clickedDate);
    // });

    //####################################  Current time marker
    // Get the timeline (this is where we add the marker)
    var timeline = chart.getTimeline();
    const scale = timeline.scale();




    // Enable zooming the chart with the mouse wheel. Does not work?
    //chart.interactivity().zoomOnMouseWheel(true);




    chart.listen("rowClick", function (e) {


        // 1) Task/period times from the clicked row
        const item = e.item;
        //const start = item.get("actualStart") || item.get("start");
        //const end = item.get("actualEnd") || item.get("end");
        //console.log("Period start:", new Date(start));
        //console.log("Period end  :", new Date(end));

        // 2) Mouse date under the cursor on the timeline
        // tlBounds is *stage-relative*
        const tlBounds = timeline.getPixelBounds(); // {left, top, width, height}

        // e.offsetX is also *stage/chart-surface relative* — no DOM/page math needed
        const xInTimeline = e.originalEvent.offsetX - tlBounds.left;

        // Ignore clicks outside the timeline panel
        if (xInTimeline < 0 || xInTimeline > tlBounds.width) return;

        let ratio = xInTimeline / tlBounds.width;          // 0..1 across visible window
        ratio = Math.max(0, Math.min(1, ratio));

        const clickedDate = new Date(scale.inverseTransform(ratio));
        //console.log("Date under cursor:", clickedDate);

        if (e.elementType === "periods") {
            //codeStopModal(e.period.id,  parseInt(e.item.get("id")));
            //console.log("rowClick", e.period.id, e.period);
            if (e.period.type === "calendar") {
                return; //do nothing on calendar clicks
            }
            onClickHandler(e.period)
            //handleOpenNewPO(e.period);
            //var itemName = e.item.get("name");
        } else {
            if (pEdit === "true") {
                handleOpenNewPO(e.item, clickedDate);
            }
        }
    });



    // Set correct Zoom level
    //####chart.fitAll();

    //console.log("anychartGantt Current time (UTC):", nowutc);
    //console.log("anychartGantt Current time (local):", now);

    now = new Date(now.getTime() - (now.getTimezoneOffset() * 60 * 1000)); // Convert local time to UTC for comparison with anychart timeline

    function nowDate() {
        const now = new Date();
        let offset = 0; //now.getTimezoneOffset() * 60000;
        return new Date(now.getTime() - offset);
    }

    // Add a vertical line marker to the timeline
    var nowMarker = timeline.lineMarker()
        .value(formatDateTimeISO(nowDate()))
        .stroke("white", 2, "10 2")  // color, width, dash pattern
        .layout("vertical");

    // Update the marker every minute (or faster if needed)
    if (activeNowMarkerIntervalId) {
        clearInterval(activeNowMarkerIntervalId);
        activeNowMarkerIntervalId = null;
    }

    let nowMarkerIntervalId = setInterval(function () {
        nowMarker.value(formatDateTimeISO(nowDate()));
    }, 60 * 1000); // update every 60 seconds
    activeNowMarkerIntervalId = nowMarkerIntervalId;

    // Clear the interval when the chart is disposed to avoid leaks and stale callbacks
    chart.listen("dispose", function () {
        const disposedIntervalId = nowMarkerIntervalId;
        if (nowMarkerIntervalId) {
            clearInterval(nowMarkerIntervalId);
            nowMarkerIntervalId = null;
        }

        if (activeNowMarkerIntervalId === disposedIntervalId) {
            activeNowMarkerIntervalId = null;
        }
    });

    // Set container for the chart
    chart.container(container);

    chart.background("#101624");
    chart.defaultRowHeight(35);


    //chart.rowStroke("5 #64b5f6");


    // Draw the chart in the container
    chart.draw();

    removeElementsByClass();

    //Initial zoom level
    //console.log ("Initial zoom level:", pZoomLevel);
    if (pZoomLevel && pZoomLevel.min && pZoomLevel.max) {
        chart.zoomTo(new Date(pZoomLevel.min), new Date(pZoomLevel.max));
    } else {
        chart.fitAll();
    }

    // set the text of the second data grid column

    var column_2 = chart.dataGrid().column(1);


    column_2.labels().useHtml(true);
    column_2.title().fontColor("#ffffff");

    column_2.labels().format(function () {

        var numChildren = this.item.numChildren();
        //var duration = (this.end - this.start) / 1000 / 3600 / 24;
        var customField = " ";
        if (this.getData("custom_field")) {
            customField = "<span style='font-weight:bold'>" +
                this.getData("custom_field") + customField + "</span>";
        }

        var parentText = "<span style='color:gray;font-weight:bold'>" +
            this.name.toUpperCase() + "<span>";

        //var childText = "<span style='color:#ffffff;font-weight:bold;'>" + this.name + "---<span>";
        //var childText = `<div class="gantt-header-container">${getStatusIcon(this)} <div style="min-width:35px"><a href='/machines/{%id}' style='color: ${"#ff00ff"}'>{%name}</a></div> ${getPriority(this)}...</div>`;


        //a checkbox for which row to update, with calling of a function when clicked
        var machineId = this.id;
        const isChecked = pMarkedForUpdate.includes(machineId.toString()) ? "checked" : "";
        let updateCheckboxes = "";
        if (this.name.includes("(rep)") && pEdit === "true") {
            updateCheckboxes = `<input type="checkbox" class="row-check" title="mark for recalculation" data-row-id="${this.id}" ${isChecked} />`;
        } else {
            updateCheckboxes = `<div style="width:14px"></div>`;
        }


        //Revert machine button
        let revertTag = "";
        if (!this.name.includes("(rep)") && !this.name.includes("(cal)") && pEdit === "true") {
            let revertImg = "<img src='/assets/restore.png' alt='Revert' height='15px'/>"
            revertTag = `<div class="row-undo" data-row-id="${this.id}" style="cursor:pointer; margin-left:10px;padding-top:0px">${revertImg}</div>`;

            let saveImg = "<img src='/assets/save.png' alt='Save' height='15px'/>"
            revertTag += `<div class="row-save" data-row-id="${this.id}" style="cursor:pointer; margin-left:5px;padding-top:0px">${saveImg}</div>`;
        }
        var childText = `<div class="gantt-header-container">${getStatusIcon(this)}<div style="min-width:55px"><a href='/machines/${this.id}'>${this.name}</a></div> <div style='margin-left:10px'> ${getPriority(this)}</div> <div style="margin-left:10px;padding-top:3px">${updateCheckboxes}</div> ${revertTag} </div>`;


        // identify the resource type and display the corresponding text
        if (numChildren > 0) {
            return parentText;
        } else {
            return childText;
        }

    });

    chart.listen("chartDraw", function () {
        // Attach click listeners to checkboxes
        document.querySelectorAll(".row-check").forEach(function (checkbox) {
            checkbox.addEventListener("change", function () {
                var rowId = this.getAttribute("data-row-id");
                onRowChecked(rowId, this.checked);
            });
        });
    });
    function onRowChecked(rowId, checked) {
        pCheckboxClick(rowId, checked);
    }

    chart.listen("chartDraw", function () {
        // Attach click listeners to undo buttons
        document.querySelectorAll(".row-undo").forEach(function (div) {
            div.addEventListener("click", function () {
                var rowId = this.getAttribute("data-row-id");
                onRowRevert(rowId);
            });
        });
    });
    function onRowRevert(rowId) {
        pRowUndoClick(rowId);
    }

        chart.listen("chartDraw", function () {
        // Attach click listeners to undo buttons
        document.querySelectorAll(".row-save").forEach(function (div) {
            div.addEventListener("click", function () {
                var rowId = this.getAttribute("data-row-id");
                onRowSave(rowId);
            });
        });
    });

    function onRowSave(rowId) {
        pRowSaveClick(rowId);
    }

    // Listen to mouseup event to capture scroll position changes
    document.getElementById("chart_container").addEventListener("mouseup", (e) => {
        const range = scale.getRange(); // { min, max } in timestamps
        pSetZoomLevel({ min: range.min, max: range.max })
    });

    //Return Chart object
    return chart;
};
